import React from "react";
import classes from "../statics/styles/icon-button.rtlignore-scss.js";
const IconButton = ({ children, isLoading, icon, ...props }) => {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: classes.audioIconButton, type: "button", disabled: isLoading, ...props }, icon), children);
};
export {
  IconButton
};
//# sourceMappingURL=icon-button.js.map
